import { Checkbox, Form } from 'antd';

export default function ReportWorkOrderSyntheticGroupedCheckbox() {
  return (
    <Form.Item
      noStyle
      name="isSyntheticGrouped"
      initialValue={false}
      valuePropName="checked"
    >
      <Checkbox>
        Sintetico (agrupado por data com total e custos de peças, serviços e
        serviços de terceiro por orçamento)
      </Checkbox>
    </Form.Item>
  );
}
